
export interface IHasCrossPriceByAge {
    getCrossPriceByAge(age: number): number | undefined
    setCrossPriceByAge(age: number, price: number): void
}

function hasCrossPriceByAge<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasCrossPriceByAge {
        private crossPriceByAge: {[age: number]: number} = {}

        constructor(...args: any[]) {
            super(...args);
        }

        public getCrossPriceByAge(age: number): number | undefined {
            return this.crossPriceByAge && this.crossPriceByAge[age]
        }
        public setCrossPriceByAge(age: number, price: number): void {
            this.crossPriceByAge[age] = price
        }
    };
}

export default hasCrossPriceByAge